import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ILocation } from '../types';
import { GlobalVariables } from '../pdf/GlobalVariables';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface IContextMenuState {
    location: ILocation | null;
}

const initialState: IContextMenuState = {
    location: null,
};

const reducers = {
    show: (state: IContextMenuState, action: PayloadAction<ILocation>) => {
        state.location = action.payload;
    },
    close: (state: IContextMenuState) => {
        GlobalVariables.contextMenuAnchor = null;
        state.location = null;
    },
};

export const contextMenuSlice = createSlice({
    name: 'contextMenu',
    initialState,
    reducers,
});

export const contextMenuLocation = (state: IGlobalStoreReducers) => state.contextMenu.location;

export const { close, show } = contextMenuSlice.actions;

export default contextMenuSlice.reducer;
